import { AVATAR_SIZES } from '@procurify/ui'
import styled from 'styled-components'

export const GreyCircleStyled = styled.div`
  --circle-size: ${(props) =>
    props.theme.typography.pxToRem(AVATAR_SIZES.small.diameterPx)};

  display: flex;
  align-items: center;
  justify-content: center;
  width: var(--circle-size);
  height: var(--circle-size);
  border-radius: 50%;
  background-color: ${(props) => props.theme.colors.content.secondaryBorder};
  color: ${(props) => props.theme.colors.text.primary};
  flex-shrink: 0;
`
